var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e0e79a690a2494b93c755f608299f04396eed453"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["mystore@snackpass-y4"]={id:"e0e79a690a2494b93c755f608299f04396eed453"};
      